<template>
  <img :src="path" alt="" />
</template>

<script>
export default {
  computed: {
    path() {
      return this.$store.state.theme.logo
    }
  }
}
</script>
